import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from 'reactstrap'
import styles from './ItalicSlatePlugin.scss'
import { TYPE, TRIGGER_KEY, hasItalic, onClickButton } from './ItalicSlatePluginContainer'

class ItalicButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { state: editorState, noTooltip, onChange, style } = this.props
    const isActive = hasItalic(editorState)

    const customStyle = {fontStyle: 'italic', fontFamily: 'serif'}

    return (
      <Button
        id={'ItalicButton' + (noTooltip ? '' : this.uid)}
        style={{...style, ...customStyle}}
        onClick={e => onChange(onClickButton(e, editorState))}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.ItalicButton}
      > I
        {
          !noTooltip &&
          <Tooltip placement='top' isOpen={this.state.tooltipOpen} target={'ItalicButton' + this.uid} toggle={this.toggle}>
            {TYPE} (CTL+{TRIGGER_KEY.toUpperCase()})
          </Tooltip>
        }
      </Button>
    )
  }
}

ItalicButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  noTooltip: PropTypes.bool,
  style: PropTypes.object
}

export default ItalicButton



// WEBPACK FOOTER //
// ./src/components/ItalicSlatePlugin/ItalicButton.js